import * as React from 'react';
import { Link } from 'react-router-dom';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { FormControl, InputLabel } from '@mui/material';


import './newsPaperForm.scss';
import { showSnackbar } from '../Notification/Snackbar';
import { postQuery } from '../../services/api/enquires';
import { Grid } from '@mui/material';




function NewsPaperForm() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({});

  /**
 * sets the form data 
 * @param {string} name the name of the field
 * @param {string} value  the value of the field
 */
  const setFormValue = (name, value) => {
    const formDataAs = { ...formData };
    setFormData({ ...formDataAs, ...{ [name]: value } });
  }

  /**
   * Validates the form and returns true if valid
   * @returns boolean
   */
  const isValidForm = () => {
    let isValid = false;
    if (formData && formData.name && formData.phoneNumber &&
      formData.email) {
      isValid = true;
    }
    return isValid;
  }

  /**
   * On submit the form
   */
  const onSubmit = () => {
    if (isValidForm()) {
      // Submitting data to backend for registration
      setIsLoading(true);

      const formPostData = {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        query: 'newsletter subscription'
      }

      postQuery(formPostData).then((data) => {
        if (data.success) {
          setFormData(null);
          showSnackbar().success(data.message)
        } else {
          showSnackbar().failure(data.message)

        }
      }).finally(() => setIsLoading(false));
    }
  };
  

  return (
    <div className='newspapper-form'>

      <div className='contct-grid-wrp f-wrp'>

        <div className='contct-form-wrp popup-content-box f-wrp'>

          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                
                margin="dense"
                id="name"
                name="name"
                label="Name"
                type="text"
                fullWidth
                className='custom-textfield'
                variant="outlined"
                required
                onChange={(e) => setFormValue('name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                
                margin="dense"
                id="email"
                name="email"
                label="Email Address"
                type="email"
                fullWidth
                className='custom-textfield'
                variant="outlined"
                required
                onChange={(e) => setFormValue('email', e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <FormControl className='custom-textfield phoneNumberWithIcon' fullWidth margin="dense" required>
                <InputLabel shrink htmlFor="phone-input">Contact Number</InputLabel>
                <PhoneInput
                  id="phone"
                  name="phoneNumber"
                  required
                  // value={formData.phoneNumber || ''}
                  onChange={(value) => setFormValue('phoneNumber', value)}
                  defaultCountry="AE"
                  className="custom-phone-input"
                />

              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <div className='news-footer-btns'>
                <div className='btn-sec'>
                  <Button disabled={!isValidForm()} onClick={onSubmit}>{isLoading ? 'Submitting...' : 'Submit'}</Button>
                </div>
                <div className='term-policy-box'>
                  <p>By clicking Submit, you agree to our <Link to={'/terms-and-conditions'}>Terms and Conditions</Link> and <Link to={'/privacy-policy'}>Privacy Policy</Link>.</p>
                </div>

              </div>

            </Grid>
          </Grid>

        </div>
      </div>
    </div>
  );
}

NewsPaperForm.propTypes = {}
export default NewsPaperForm
